import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import React from "react";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { useForm } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { WSIcons } from "../../commonFunctions/iIcons";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import Firm from "./EditFirm";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { useNavigate } from "react-router-dom";
import WSRadioField from "../../Components/Radio/WSRadio";

export const Transactions: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset, watch } = useForm();
  // Watch the deliveryChallan checkbox
  const deliveryChallanChecked = watch("deliveryChallan", false);
  const navigate = useNavigate();

  const handleClick = () => {
    openPopUp(metadata, handleData, "60rem");
  };
  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const metadata: IMetaData = {
    title: "Edit Firm",
    hideActions: false,
    content: (props: any, row: any) => <Firm {...props} />,
    actions: [
      {
        label: "Cancel",
        // onClick: handleCloseDialog,
        className: "ws-cancel",
        type: "button",
      },
      {
        label: "Save",
        type: "submit",
        onClick: handleData,
        autoFocus: true,
      },
    ],
    isDragable: true,
  };

  const handleCancelClick = () => {
    navigate("/");
  };
  return (
    <Grid p={2}>
      <Paper sx={{ padding: 3, position: "relative" }} elevation={0}>
        {/* Close Icon in top right */}
        <IconButton
          size="small"
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={handleCancelClick} // replace with your close logic
        >
          <WSIcons.CloseIcon fontSize="small" />
        </IconButton>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Transaction Header</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Invoice/Bill No"
                  id="invoiceNo"
                  control={control}
                  {...register("invoiceNo")}
                  rules={{ required: false }}
                  name="invoiceNo"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Add Time on Transactions"
                  id="TimeonTransactions"
                  control={control}
                  {...register("TimeonTransactions")}
                  rules={{ required: false }}
                  name="TimeonTransactions"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Cash Sale by default"
                  id="CashSalebydefault"
                  control={control}
                  {...register("CashSalebydefault")}
                  rules={{ required: false }}
                  name="CashSalebydefault"
                />
              </Grid>

              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Billing Name of Parties"
                  id="BillingNameofParties"
                  control={control}
                  {...register("BillingNameofParties")}
                  rules={{ required: false }}
                  name="BillingNameofParties"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Customers P.O. Details on Transactions"
                  id="PODetailsonTransactions"
                  control={control}
                  {...register("PODetailsonTransactions")}
                  rules={{ required: false }}
                  name="PODetailsonTransactions"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>More Transaction Features</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="E-way bill no"
                  id="Ewaybillno"
                  control={control}
                  {...register("Ewaybillno")}
                  rules={{ required: false }}
                  name="Ewaybillno"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Quick Entry"
                  id="QuickEntry"
                  control={control}
                  {...register("QuickEntry")}
                  rules={{ required: false }}
                  name="QuickEntry"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Do not Show Invoice Preview"
                  id="donotShowInvoicePreview"
                  control={control}
                  {...register("donotShowInvoicePreview")}
                  rules={{ required: false }}
                  name="donotShowInvoicePreview"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Passcode for transaction edit/delete"
                  id="enablePasscode"
                  control={control}
                  {...register("enablePasscode")}
                  rules={{ required: false }}
                  name="enablePasscode"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Discount During Payments"
                  id="discountDuringPayments"
                  control={control}
                  {...register("discountDuringPayments")}
                  rules={{ required: false }}
                  name="discountDuringPayments"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Link Payments to Invoices"
                  id="LinkPaymentstoInvoices"
                  control={control}
                  {...register("LinkPaymentstoInvoices")}
                  rules={{ required: false }}
                  name="LinkPaymentstoInvoices"
                />
              </Grid>
                  <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Due Dates and Payment Terms"
                      id="dueDatesandPaymentTerms"
                      control={control}
                      {...register("dueDatesandPaymentTerms")}
                      rules={{ required: false }}
                      name="dueDatesandPaymentTerms"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Show Profit while making Sale Invoice"
                      id="showProfitwhilemakingSaleInvoice"
                      control={control}
                      {...register("showProfitwhilemakingSaleInvoice")}
                      rules={{ required: false }}
                      name="showProfitwhilemakingSaleInvoice"
                    />
                  </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Items Table</Typography>

                <Divider />
              </Grid>
              <Grid item xs={12}>
                 <WSSCheckBoxField
                      label="Inclusive/Exclusive Tax on Rate(Price/Unit)"
                      id="inclusiveTaxOnRate"
                      control={control}
                      {...register("inclusiveTaxOnRate")}
                      rules={{ required: false }}
                      name="inclusiveTaxOnRate"
                    />
              </Grid>
                <Grid item xs={12}>
                 <WSSCheckBoxField
                      label="Display Purchase Price of Items"
                      id="inclusiveTaxOnRate"
                      control={control}
                      {...register("inclusiveTaxOnRate")}
                      rules={{ required: false }}
                      name="displayPurchasePriceofItems"
                    />
              </Grid>
                <Grid item xs={12}>
                 <WSSCheckBoxField
                      label="Show last 5 Sale Price of Items"
                      id="Showlast5SalePriceofItems"
                      control={control}
                      {...register("Showlast5SalePriceofItems")}
                      rules={{ required: false }}
                      name="Showlast5SalePriceofItems"
                    />
              </Grid>
                 <Grid item xs={12}>
                 <WSSCheckBoxField
                      label="Free Item Quantity"
                      id="freeItemQuantity"
                      control={control}
                      {...register("freeItemQuantity")}
                      rules={{ required: false }}
                      name="freeItemQuantity"
                    />
              </Grid>
               <Grid item xs={12}>
                 <WSSCheckBoxField
                      label="Count"
                      id="count"
                      control={control}
                      {...register("count")}
                      rules={{ required: false }}
                      name="count"
                    />
              </Grid>
              <Grid item xs={12} >
                <Typography fontWeight={"bold"}>
                 Transaction Prefixes
                </Typography>

                <Divider />
              </Grid>
              <Grid item xs={12}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="firm"
                {...register("firm")}
                name="firm"
                label="Firm"
              />
              </Grid>
               <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="sale"
                {...register("sale")}
                name="sale"
                label="Sale"
              />
              </Grid>
              <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="CreditNote"
                {...register("CreditNote")}
                name="CreditNote"
                label="Credit Note"
              />
              </Grid>
               <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="saleOrder"
                {...register("saleOrder")}
                name="saleOrder"
                label="Sale Order"
              />
              </Grid>
               <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="purchaseOrder"
                {...register("purchaseOrder")}
                name="purchaseOrder"
                label="Purchase Order"
              />
              </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="estimate"
                {...register("estimate")}
                name="estimate"
                label="Estimate"
              />
              </Grid>
               <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="proformaInvoice"
                {...register("proformaInvoice")}
                name="proformaInvoice"
                label="Proforma Invoice"
              />
              </Grid>
              <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="deliveryChallan"
                {...register("deliveryChallan")}
                name="deliveryChallan"
                label="Delivery Challan"
              />
              </Grid>
              <Grid item xs={12} sm={6}>
                  <WSSelectField
                rules={{ required: true }}
                control={control}
                id="paymentIn"
                {...register("paymentIn")}
                name="paymentIn"
                label="Payment In"
              />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Taxes, Discount & Totals</Typography>

                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Transaction wise Tax"
                  id="transactionwiseTax"
                  control={control}
                  {...register("transactionwiseTax")}
                  rules={{ required: false }}
                  name="transactionwiseTax"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Transaction wise Discount"
                  id="transactionwiseDiscount"
                  control={control}
                  {...register("transactionwiseDiscount")}
                  rules={{ required: false }}
                  name="transactionwiseDiscount"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Round Off Tota"
                  id="roundOffTotal"
                  control={control}
                  {...register("roundOffTotal")}
                  rules={{ required: false }}
                  name="roundOffTotal"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Billing Type</Typography>

                <Divider />
              </Grid>
              <Grid item xs={12}>
                 <WSRadioField
                    defaultValue={""}
                    control={control}
                    label=""
                    rules={{ required: false }}
                    id=""
                    name=""
                    options={[
                      {
                        label: "Lite Sale",
                        value: "Lite Sale",
                      },
                      {
                        label: "Full Sale",
                        value: "Full Sale",
                      }
                    ]}
                  />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
});
